"use client";
import { useTranslations } from "@zapier/i18n";

import { Icon } from "@zapier/zinnia-icons";
import { BetaPageHeader, Link } from "@zapier/design-system";
import {
  useEmitZapCreateEvent,
  DefaultViewButton,
  useRouterParams,
} from "@zapier/shared";
import {
  getCreateZapUrl,
  getFolderUrl,
  PENDING_FOLDER_NAME,
} from "@zapier/utils";
import { FolderZapToggle } from "../../shared/components/FolderZapToggle";
import { ZapFilterBar } from "./ZapFilterBar";
import styles from "./ZapsHeader.module.css";

import { useSplitTreatments, useSupportedAssets } from "@zapier/client";
import { TrashButton } from "../../shared/components/TrashButton/TrashButton";

interface ZapsHeaderProps {
  showSearch?: boolean;
}

export function ZapsHeader({ showSearch }: ZapsHeaderProps) {
  const t = useTranslations("zaps-header");

  const { virtual } = useRouterParams();
  const emitCreate = useEmitZapCreateEvent();

  const isBillingPending = virtual === PENDING_FOLDER_NAME;
  const hideFilters = !!virtual && !isBillingPending;

  const { isMPFEnabled } = useSupportedAssets();
  const showFolderZapToggle = !isMPFEnabled;
  const { isZapAndCanvasUnifiedTrashEnabled } = useSplitTreatments();

  return (
    <BetaPageHeader
      title={t("page-title")}
      actions={
        <>
          {/* Once unified trash is on, Trash lives in the sidebar (desktop) and
              the asset nav tabs' overflow menu (mobile), so hide this button. */}
          {!isZapAndCanvasUnifiedTrashEnabled && (
            <TrashButton href={getFolderUrl("trash")} />
          )}
          <Link href={getCreateZapUrl()} variant="primary" onClick={emitCreate}>
            <Icon name="formAdd" aria-hidden={true} />
            {t("create-button")}
          </Link>
        </>
      }
      additionalContent={
        <div className={styles.root}>
          <div className={styles.topRow}>
            {showFolderZapToggle && (
              <div>
                <FolderZapToggle />
              </div>
            )}

            {!hideFilters && (
              <ZapFilterBar isDisabled={!showSearch} showFiltersButton />
            )}

            {!hideFilters && <DefaultViewButton />}
          </div>
        </div>
      }
    />
  );
}
